import { query } from '@confluence/query-preloader-tools';

import { RequestViewQuery } from './RequestViewQuery.graphql';

export function preloadRequestViewQuery(id: string) {
	return query({ query: RequestViewQuery, variables: { id } });
}
